import { money } from "./api";
import { FALLBACK } from "@/data";

const NAMES = Object.fromEntries(FALLBACK.variants.map((v) => [v.id, v.name]));

export default function AdminStats({ stats }) {
  if (!stats) return <div className="vf-admin-stats" data-testid="admin-stats-loading"><p className="vf-admin-muted">Chargement…</p></div>;
  const low = stats.low_stock.map((id) => NAMES[id] || id);
  return (
    <section className="vf-admin-stats" data-testid="admin-stats">
      <div><span>Commandes</span><strong data-testid="stat-orders-total">{stats.orders_total}</strong></div>
      <div><span>Chiffre d'affaires encaissé</span><strong data-testid="stat-revenue">{money(stats.revenue)}</strong></div>
      <div><span>À préparer</span><strong data-testid="stat-to-process">{stats.to_process}</strong></div>
      <div className={low.length ? "alert" : ""}>
        <span>Stock faible</span>
        <strong data-testid="stat-low-stock">{low.length ? low.join(" · ") : "Aucun"}</strong>
      </div>
    </section>
  );
}
